import { Card, CardContent, CardFooter } from "../ui/card";
import { Skeleton } from "../ui/skeleton";

export const CourseCardSkeleton = () => {
  return (
    <Card>
      <CardContent>
        <Skeleton className="aspect-9/4 w-full rounded-2xl" />

        <div className="my-3 flex w-fit items-center gap-4">
          <Skeleton className="size-8 shrink-0 rounded-full" />
          <div className="grid gap-2">
            <Skeleton className="h-4 w-37" />
          </div>
        </div>

        <Skeleton className="mb-3 h-6 w-[90%]" />
        <Skeleton className="mb-4 h-4 w-50" />

        <div className="mb-5 flex w-fit items-center gap-4">
          <Skeleton className="h-5 w-35" />
          <Skeleton className="h-5 w-37" />
        </div>
        <div className="mb-4 flex w-full items-center justify-between gap-4 pt-1">
          <Skeleton className="h-3.75 w-16.75" />
          <Skeleton className="h-4.5 w-37" />
        </div>
      </CardContent>
      <CardFooter className="bg-card justify-between gap-3">
        <Skeleton className="h-10 w-40" />
        <Skeleton className="h-10 w-35" />
      </CardFooter>
    </Card>
  );
};
